class MarmetoProductCard extends HTMLElement {
  constructor() {
    super();

    this.addEventListener("click", (event) => {
      const swatchButton = event.target.closest(".bgImg");

      if (swatchButton) {
        event.preventDefault();
        this.variantChange(event);
        return false;
      }
    });
  }

  variantChange(event) {
    const swatch = event.target.closest(".swatch-element");
    if (!swatch) return;

    const input = swatch.querySelector("input");
    if (!input) return;

    const mainPrice = this.querySelector(".main-price");
    const comparePrice = this.querySelector(".featured--product__compared-price");
    const discount = this.querySelector(".discount-percentages");
    const image = this.querySelector(".featured--product__image img");
    const formInput = this.querySelector('product-form input[name="id"]');

    if (formInput) {
      formInput.value = input.dataset.variant;
    }

    if (mainPrice && input.dataset.price) {
      mainPrice.textContent = input.dataset.price;
    }

    if (image && input.dataset.image) {
      image.src = input.dataset.image;
    }

    if (comparePrice) {
      if (this.dataset.flshSale === "true" && input.dataset.comparePrice) {
        comparePrice.textContent = input.dataset.comparePrice;
        comparePrice.style.display = "";
      } else {
        comparePrice.textContent = "";
        comparePrice.style.display = "none";
      }
    }

    if (discount) {
      if (input.dataset.discount) {
        discount.innerHTML = `${input.dataset.discount} <span>OFF</span>`;
      } else {
        discount.innerHTML = "";
      }
    }

    this.querySelectorAll(".bgImg").forEach((item) => {
      item.classList.remove("swatch-active");
    });

    const activeSwatch = swatch.querySelector(".bgImg");
    if (activeSwatch) {
      activeSwatch.classList.add("swatch-active");
    }
  }
}

customElements.define("marmeto-product-card", MarmetoProductCard);